"use client";

import { useEffect, useState } from "react";
import { io } from "socket.io-client";
import { CONFIG } from "../../lib/util/config";

const socketServerUrl = CONFIG.socketServerUrl;
const enableSocket = CONFIG.enableSocket;
const socketMode = CONFIG.socketMode;

export const useSocket = (connectTrigger = false) => {
  const [socket, setSocket] = useState(null);
  const [connection, setConnection] = useState({
    connect: connectTrigger,
    isConnected: false,
    connecting: false,
    count: 0,
    lastPong: "",
  });

  useEffect(() => {
    if (!enableSocket) return;
    if (!connection.connect && socket) return;

    const SERVER = socketServerUrl ? socketServerUrl.toString() : "";

    const newSocket = io(SERVER, {
      transports: [socketMode],
      upgrade: false,
      timeout: 60000,
      reconnection: true,
      forceNew: true,
    });

    setSocket(newSocket);

    newSocket.on("connect", () => {
      setConnection((prev) => ({ ...prev, isConnected: true, connecting: false }));
    });

    newSocket.on("connect_error", () => {
      setConnection((prev) => ({ ...prev, isConnected: false, connecting: false }));
    });

    newSocket.on("disconnect", () => {
      setConnection((prev) => ({
        ...prev,
        isConnected: false,
        lastPong: new Date().toISOString(),
      }));
    });

    setConnection((prev) => ({
      ...prev,
      connect: false,
      connecting: true,
      count: prev.count + 1,
    }));

    return () => {
      newSocket.off("connect");
      newSocket.off("disconnect");
      newSocket.off("pong");
      newSocket.close();
    };
  }, [connection.connect]);

  return { socket, connection, setConnection };
};
